import React, { useCallback, useContext } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import c from 'classnames';
import { Url } from '@wix/da-url';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import DeviationFlag from '@wix/da-ds/pkg/Indicators/DeviationFlag';
import { formatDate, DATE_FORMATS } from '@wix/da-ds/pkg/Time/functions';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import UserLink from '../../../../../User/Link/UserLink';
import LegacyTextRenderer from '../../../../../TextRenderer/LegacyTextRenderer';
import { ResourceType } from '../../../../../types/resource';
import { getRecipientForDeviation } from '../../../../../coreBadge/utils';
import { CoreBadgeType } from '../../../../../coreBadge/types';
import { usePushModal } from '../../../../../utils/hooks/usePushModal';
import { ModalType } from '../../../../../Modals/redux/types';
import s from './DeviationFlagCard.scss';
const DeviationFlagCard = ({ variant, deviation })=>{
    const { t } = useTranslation();
    const { isLoggedIn } = useContext(SessionContext);
    const pushAwardsModal = usePushModal(ModalType.RECEIVED_AWARDS);
    const hypeOnClick = useCallback(()=>{
        var _deviation_extended;
        pushAwardsModal({
            badges: ((_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.awardedBadges) || {},
            typeId: ResourceType.DEVIATION,
            itemId: deviation.deviationId,
            recipient: getRecipientForDeviation(deviation),
            defaultActiveType: CoreBadgeType.HYPE
        });
    }, [
        pushAwardsModal,
        deviation
    ]);
    let title, subtitle, cta, ctaLink, ctaOnClick, ctaBiData, description;
    switch(variant){
        case 'daily-deviation':
            if (!deviation.dailyDeviation) {
                return null;
            }
            const { body, time, giver, suggester } = deviation.dailyDeviation;
            title = t('actionbar.flags.dailyDeviation.title');
            subtitle = t('actionbar.flags.dailyDeviation.subtitle', {
                date: formatDate(time, DATE_FORMATS.Date.Full)
            });
            cta = t('actionbar.flags.dailyDeviation.cta');
            ctaLink = Url.browseDailyDeviationsLink();
            description = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(LegacyTextRenderer, {
                className: s['dd-body'],
                html: body
            }), /*#__PURE__*/ React.createElement("div", {
                className: s['dd-attribution']
            }, /*#__PURE__*/ React.createElement("div", {
                className: s['giver']
            }, /*#__PURE__*/ React.createElement(Trans, {
                i18nKey: "actionbar.flags.dailyDeviation.featuredBy"
            }, "Featured by", /*#__PURE__*/ React.createElement(UserLink, {
                user: giver,
                className: s['user-link']
            }))), suggester && /*#__PURE__*/ React.createElement("div", {
                className: s['suggester']
            }, /*#__PURE__*/ React.createElement(Trans, {
                i18nKey: "actionbar.flags.dailyDeviation.suggestedBy"
            }, "Suggested by", /*#__PURE__*/ React.createElement(UserLink, {
                user: suggester,
                className: s['user-link']
            })))));
            break;
        case 'hype':
            const hypeKbUrl = 'https://www.deviantartsupport.com/en/article/what-are-badges-and-fragments';
            title = t('actionbar.flags.hype.title');
            cta = t('actionbar.flags.hype.cta');
            ctaOnClick = hypeOnClick;
            ctaBiData = BiData({
                evid: 2,
                typeid: BiContextProvidedValue,
                itemid: BiContextProvidedValue,
                click_info: ReferralType.BADGES_LOG_HYPE
            });
            description = /*#__PURE__*/ React.createElement(Trans, {
                i8nKey: "actionbar.flags.hype.description"
            }, "Deviations awarded with Hype badges are promoted for more deviants to see.", /*#__PURE__*/ React.createElement("a", {
                href: hypeKbUrl,
                target: "_blank",
                rel: "noreferrer",
                className: s['hype-kb-link']
            }, "Learn more"));
            break;
        default:
            return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], 'ds-surface-tertiary')
    }, /*#__PURE__*/ React.createElement(DeviationFlag, {
        variant: variant,
        size: "large",
        className: s['flag']
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['content']
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: s['title']
    }, title), subtitle && /*#__PURE__*/ React.createElement("div", {
        className: s['subtitle']
    }, subtitle), /*#__PURE__*/ React.createElement("div", {
        className: s['description']
    }, description), isLoggedIn && /*#__PURE__*/ React.createElement(TextButton, {
        href: ctaLink,
        onClick: ctaOnClick,
        biData: ctaBiData,
        size: "medium",
        variant: "approval-green",
        noHorizontalPaddings: true
    }, cta)));
};
DeviationFlagCard.displayName = 'DeviationFlagCard';
export default DeviationFlagCard;

//# sourceMappingURL=DeviationFlagCard.js.map